export const CREATE_PROVIDER_INSTRUCTION = 1
export const CREATE_AD_INSTRUCTION = 2
export const ACCPET_AD_INSTRUCTION = 3